const Loader = ({style}) => {
    return (
        <div className="flex justify-center items-center">
            <div className={(style?'border-white':'border-blue-500')+" w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"}/>
        </div>
    );
};

export default Loader;
